import { defineStore } from 'pinia'
import { notificationStatusApi } from '@/apis/notificationStatusApi'

export interface INotificationState {
    isHistoryUnread: boolean
}

export const useNotificationStore = defineStore('NotificationStore', {
    state: (): INotificationState => ({
        isHistoryUnread: false,
    }),
    actions: {
        async fetch() {
            try {
                const response = await notificationStatusApi.get()
                this.isHistoryUnread = response.isHistoryUnread
            }
            catch (error) {
                console.error(error)
            }
        },
    },
})
